import request from "../../Request";
import {rThen} from "../../requestThen";

export let getPlayerStats = async (id) => {

    return request.get(`/api/olymp/get_players_stats/${id}`, true).then(r => {
        return rThen(r);
    })
}